import { render, staticRenderFns } from "./DiscountSingleDates.vue?vue&type=template&id=bc04fa1e&"
import script from "./DiscountSingleDates.vue?vue&type=script&lang=js&"
export * from "./DiscountSingleDates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports